export const CopyCabanaLibre = {
  locale: 'en',
  messages: {
    en: {
      common: {
        confirm: "confirm",
        cancel: "cancel",
        yes: "yes",
        no: "no",
      },
      toolbar: {
        title_portfolio: "Home",
        path_portfolio: "/home",
        title_events: "Events",
        path_events: "/events",
        title_tickets: "Entrances",
        path_tickets: "/entrances",
        title_checkout: "Checkout",
        path_checkout: "/checkout",
        title_tokens: "Tokens",
        path_tokens: "/tokens",
        title_account: "Account",
        path_account: "/account",
        title_signin: "Sign in",
        path_signin: "/sign-in",
        title_signup: "Create account",
        path_signup: "/sign-up",
        title_signout: "Sign Out",
        path_signout: "/sign-out",
        title_scanner: "QR Scanner",
        path_scanner: "/internal/scanner",
        title_admin: "Admin Panel",
        path_admin: "/internal/admin/table",
      },
      auth: {
        email: "Email",
        password: "Password",
        name: "Name",
        surname: "Surname",
        referral: "What brought you here?",
        instagram: "Instagram",
        document: "ID/NIE/DNI #",
        phone: "Phone Number",
        short_instagram: "IG",
        short_no_instagram: "NO IG",
        terms: "Terms of Use",
        terms_text: "<h1>Privacy Policy for Cabana Libre</h1>\n\n\nMy Website one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by My Website and how we use it.\n\n\nIf you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.\n\n\nThis privacy policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in&My Website. This policy is not applicable to any information collected offline or via channels other than this website.\n\n<b>Consent</b>\n\n\nBy using our website, you hereby consent to our Privacy Policy and agree to its terms.\n\n\n<b>Information we collect</b>\n\n\nThe personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.\n\n\nIf you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.\n\n\nWhen you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.\n\n\n<b>How we use your information</b>\n\n\nWe use the information we collect in various ways, including to:\n\n\n &#x2022; Provide, operate, and maintain our website\n &#x2022; Improve, personalize, and expand our website\n &#x2022; Understand and analyze how you use our website\n &#x2022; Develop new products, services, features, and functionality\n &#x2022; Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes\n &#x2022; Send you emails\n &#x2022; Find and prevent fraud\n &#x2022; Log Files\n\nMy Website follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.\n\n\n<b>Cookies and Web Beacons</b>\n\n\nLike any other website, My Website uses cookies. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.\n\n\n<b>DoubleClick DART Cookie</b>\n\n\nGoogle is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – <a href='https://policies.google.com/technologies/ads&'>https://policies.google.com/technologies/ads</a>\n\n\nSome of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.\n\n\n &#x2022; Google: <a href='https://policies.google.com/technologies/ads'>https://policies.google.com/technologies/ads</a>\n\n\n<b>Advertising Partners Privacy Policies</b>\n\n\nYou may consult this list to find the Privacy Policy for each of the advertising partners of&My Website.\n\n\nThird-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on&My Website, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.\n\n\nNote that My Website has no access to or control over these cookies that are used by third-party advertisers.\n\n\n<b>Third-Party Privacy Policies</b>\n\n\nMy Website's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You may find a complete list of these Privacy Policies and their links here: Privacy Policy Links.\n\n\nYou can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites. <a href='https://www.privacypolicygenerator.info/privacy-policy-cookies-clauses/'>What Are Cookies?</a>\n\n\n<b>CCPA Privacy Policy (Do Not Sell My Personal Information)</b>\n\n\nUnder the CCPA, among other rights, California consumers have the right to:\n\n\nRequest that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.\nRequest that a business delete any personal data about the consumer that a business has collected.\nRequest that a business that sells a consumer's personal data, not sell the consumer's personal data.\n\nIf you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.\n\n\n<b>GDPR Privacy Policy (Data Protection Rights)</b>\n\n\nWe would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:\n\n\nThe right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.\nThe right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.\nThe right to erasure – You have the right to request that we erase your personal data, under certain conditions.\nThe right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.\nThe right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.\nThe right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.\n\nIf you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.\n\n\n<b>Children's Information</b>\n\n\nAnother part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.\n\n\nMy Website does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.\n\n\n<b>Questions</b>\n\n\nIf you have any questions about this Privacy Policy, please contact us.",
        optional: "<em style='font-size: 12px'>(optional)</em>",
        prefill_banner: "You're a member already! We've sent you an invitation email to finish the registration. Or you can continue by filling up the form below.",
        account: {
          title: "Your Account",
          subtitle: "Thanks for keeping your contact details up to date! You wouldn't want to miss out on the next invitation!",
          details: "Cabanier Info",
          email_change: " *Contact us regarding the email change",
          delete_account: "Delete your account"
        },
        signup: {
          title: "Join the Cabana Libre Universe",
          subtitle: "Super happy that you want to join us in our next adventures! Let's get you started ✨First step to enter our universe is choosing your username and setting-up a strong password!",
          subtitle_details: "You can join our events once you become a member of our non profit cultural association ✨ Fill in the details below to start unlocking the gate towards your next magical experience 💫",
          details: "Cabanier Info",
          credentials: "Your Credentials",
          password_validation: "*at least 8 characters",
          email_validation: "*invalid format",
          email_exists: "*already exists!",
          email_registered: " *Email registered",
          button_submit: "Submit",
          modal_user_exists: {
            modal_title: "User exists!",
            title: "Email alredy exists<br>at <b>*site*</b>!",
            button: "Sign in instead"
          }
        },
        signin: {
          title: "Sign in",
          subtitle: "Your entry into the Cabana Libre Universe",
          forgotten_password: "Forgotten password",
          invalid_credentials: "Invalid Credentials!",
          create_account: "Create Account"
        },
        signout: {
          message: "See you later! &#x1F495;"
        },
        forgotten_password: {
          modal_title: "Forgotten password",
          title: "Let's get you back in!",
          subtitle: "We'll send an email with renewal link to the&nbsp;following&nbsp;address:",
          email: "Email",
          button_send: "Send"
        },
        reset_password: {
          modal_title: "Reset yout Password",
          password: "New Password",
          password_validation: " *at least 8 characters"
        },
        delete_account: {
          modal_title: "Delete your account",
          title: "Sign in",
          subtitle: "To delete your Account",
          button_delete: "Delete"
        }
      },
      portfolio: {
        heading_first: "Cabana Libre is a <b>non-profit cultural association</b> of <b>local and international artists</b> that strives to transform <b>unique locations</b> into alternate universes</b>, through their <b>love for music, decorations and bringing people together.</b>",
        heading_second: "Our events are exclusive - <b>everyone needs to register first.</b> That's how we make sure the environment is filled with good-vibes people, and that every person you meet is your&nbsp;next&nbsp;friend! <br><b>We collaborate with both local and international artists</b> who share our value of bringing joy and serenity to your experience.",
        link_youtube: "https://www.youtube.com/embed/GnxBLDl805o",
        divider: {
          first: "Next Event",
          second: "Our Pillars",
          third: "Gallery",
          fourth: "Core Values",
          fifth: "Follow Us"
        },
        content_first: [
          {
            id: 1,
            title: "Music",
            subtitle: "We play with passion",
            text: "We set the vibe and the rhythm. Our music complements the atmosphere created by our decorations. Live artists with different styles bring the people together under one vision"
          },
          {
            id: 2,
            title: "People",
            subtitle: "Community-made events",
            text: "We fuse the event with your daily life. We build a collective consciousness, looking after one another, and nurturing a sense of belonging."
          },
          {
            id: 3,
            title: "Decoration",
            subtitle: "DIY is our middle name",
            text: "Step into a world of creativity, emotion, and art. Our team creates mesmerising decorations and themes that will transport you to a different realm."
          }
        ],
        content_second: [
          {
            id: 4,
            title: "Make No Assumptions",
            subtitle: "We are aligned in thought and action",
            text: "We keep an open mind and embrace all possibilities.\nWe come into all of our projects with a blank canvas, and leave all assumptions at the door."
          },
          {
            id: 5,
            title: "No Idea is Too Crazy",
            subtitle: "We love dreaming out loud",
            text: "Bring us your wildest ideas, your maddest fantasies, and your burning questions about life.\nWe’ll make them happen. Go wild!"
          },
          {
            id: 6,
            title: "Save the Whales",
            subtitle: "We care about the environment",
            text: "We are committed to at least trying to relieve some of the stress we cause our planet.\nPart of the proceeds from our events go towards sustainable initiatives."
          }
        ],
        contact_us: {
          first: 'https://www.instagram.com/cabanalibre/',
          second: 'https://www.facebook.com/CabanaLibreInt',
          third: 'https://soundcloud.com/cabanalibre',
          fourth: 'https://www.twitch.tv/cabanalibre'
        },
        copyright: "Copyright&nbsp;©&nbsp;2022&nbsp;Cabana&nbsp;Libre. All&nbsp;rights&nbsp;reserved."
      },
      events: {
        divider: {
          past_events: "Past Events"
        },
        more_details: "Get more details",
        show_tickets: "Show entrances",
        add_to_calendar: "Add to calendar",
        message: {
          not_registered: "*You need to register first.",
          purchased: "You have purchased your entrances!",
          pre_approved: "You have been pre-approved!",
          registartion_pending: "Your registration is pending on approval.<br>It might take us a day or two",
          purchase: "Purchase",
          purchase_more: "Purchase +1",
          no_reg: "Registration Opening Soon!",
        },
        modal: {
          title_register: "Register to event",
          subtitle_signin: "Do you have an account?",
          subtitle_signup: "Your first time here?"
        },
        progress_bar: {
          step_one: "Registration",
          step_two: "Approval",
          step_three: "Experience",
        },
        open_registration: {
          email: "Your email",
          instagram: "Instagram",
          referral: "What brought you here?",
          short_instagram: "IG",
          short_no_instagram: "NO IG",
          button_register: "Register"
        }
      },
      tickets: {
        no_tickets: {
          title: "You don't have any entrances yet!",
          subtitle: "Check out the next event!"
        },
        divider: {
          past_tickets: "Past Events"
        },
        buttons: {
          first: "Info Package",
          second: "WhatsApp Group",
          third: "Share / Resell"
        }
      },
      checkout: {
        currency: "€",
        service_fee: "Service Fee",
        service_fee_item: "Service Fee <i>per item</i>",
        total_price: "Total",
        button_confirm: "Confirm",
        button_disabled: "Disabled",
        button_pay: "Pay now!"
      },
      internal: {
        assign_ticket: "Assign Ticket",
        assign_token: "Assign Tokens",
        block_user: "Block User",
        remove_tickets: "Remove Tickets",
        remove_tokens: "Remove Tokens",
      }
    }
  }
}


  



